export const FETCH_SENGAGE_DATA_INIT = 'FETCH_SENGAGE/DATA_INIT';
export const FETCH_SENGAGE_DATA_SUCCESS = 'FETCH_SENGAGE/DATA_SUCCESS';
export const FETCH_SENGAGE_DATA_FAIL = 'FETCH_SENGAGE/DATA_FAIL';

export const FETCH_SENGAGE_TIMELINE_DATA_INIT = 'FETCH_SENGAGE/TIMELINE_DATA_INIT';
export const FETCH_SENGAGE_TIMELINE_DATA_SUCCESS = 'FETCH_SENGAGE/TIMELINE_DATA_SUCCESS';
export const FETCH_SENGAGE_TIMELINE_DATA_FAIL = 'FETCH_SENGAGE/TIMELINE_DATA_FAIL';

/** Granular campaign date ranges for the timeline / Gantt section (`/smart_engage/campaigns`). */
export const FETCH_SENGAGE_CAMPAIGN_FRAMES_INIT = 'FETCH_SENGAGE/CAMPAIGN_FRAMES_INIT';
export const FETCH_SENGAGE_CAMPAIGN_FRAMES_SUCCESS = 'FETCH_SENGAGE/CAMPAIGN_FRAMES_SUCCESS';
export const FETCH_SENGAGE_CAMPAIGN_FRAMES_FAIL = 'FETCH_SENGAGE/CAMPAIGN_FRAMES_FAIL';

/** Day-part × day heatmap of return-visit patterns (`/timing_patterns`). */
export const FETCH_TIMING_PATTERNS_INIT = 'FETCH_SENGAGE/TIMING_PATTERNS_INIT';
export const FETCH_TIMING_PATTERNS_SUCCESS = 'FETCH_SENGAGE/TIMING_PATTERNS_SUCCESS';
export const FETCH_TIMING_PATTERNS_FAIL = 'FETCH_SENGAGE/TIMING_PATTERNS_FAIL';

/** Outlet ranking table (`/outlet_ranking`). */
export const FETCH_OUTLET_RANKING_INIT = 'FETCH_SENGAGE/OUTLET_RANKING_INIT';
export const FETCH_OUTLET_RANKING_SUCCESS = 'FETCH_SENGAGE/OUTLET_RANKING_SUCCESS';
export const FETCH_OUTLET_RANKING_FAIL = 'FETCH_SENGAGE/OUTLET_RANKING_FAIL';

/** Returns/Redemptions by promo mechanics — per-campaign tier comparison (`/promo_mechanics`). */
export const FETCH_PROMO_MECHANICS_INIT = 'FETCH_SENGAGE/PROMO_MECHANICS_INIT';
export const FETCH_PROMO_MECHANICS_SUCCESS = 'FETCH_SENGAGE/PROMO_MECHANICS_SUCCESS';
export const FETCH_PROMO_MECHANICS_FAIL = 'FETCH_SENGAGE/PROMO_MECHANICS_FAIL';
